
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","viewBox":"0 0 30 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M.1 20V0h10v20H.1z","fill":"#000"}}),_c('path',{attrs:{"d":"M10 20V0h10v20H10z","fill":"#FFE936"}}),_c('path',{attrs:{"d":"M20 20V0h10v20H20z","fill":"#FF0F21"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"d":"M0 3a3 3 0 013-3h24a3 3 0 013 3v14a3 3 0 01-3 3H3a3 3 0 01-3-3V3z","fill":"#fff"}})])])])
          )
        }
      }
    